import { useCallback, useContext, useMemo, type FC } from 'react';
import { getRRuleFromString } from '@kizen/rrule';
import {
  RRuleScheduler,
  RRuleSchedulerState,
} from 'ts-components/AutomationEngine/Scheduler';
import { SmartConnectorContext } from '../../context';

export const Schedule: FC<{
  rrule?: string | null;
  isAdvanced?: boolean;
  onChange: (value: RRuleSchedulerState) => void;
}> = ({ rrule, onChange, isAdvanced = false }) => {
  const { errors, setErrors } = useContext(SmartConnectorContext);

  const { occurrences } = useMemo(
    () => getRRuleFromString(rrule || ''),
    [rrule]
  );

  const setError = useCallback(
    (error: string | null) => {
      setErrors((prev) => ({
        ...prev,
        schedule_rrule: error ? [error] : undefined,
      }));
    },
    [setErrors]
  );

  return (
    <RRuleScheduler
      rrule={rrule || ''}
      onChange={onChange}
      isAdvanced={isAdvanced}
      occurrences={occurrences}
      error={errors['schedule_rrule']?.[0] || null}
      setError={setError}
    />
  );
};
